var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialogCreat },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "drawer_content" }, [
                  _c(
                    "div",
                    { staticClass: "info_conts" },
                    [
                      _c(
                        "div",
                        { staticClass: "info_subject" },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入任务名称，200字以内",
                              autosize: { minRows: 1, maxRows: 5 },
                              maxlength: "200",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.dialogCreat.taskname,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogCreat, "taskname", $$v)
                              },
                              expression: "dialogCreat.taskname",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "info" }, [
                        _c(
                          "div",
                          { staticClass: "info_key" },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#ff4d42",
                                  "margin-right": "3px",
                                },
                              },
                              [_vm._v("*")]
                            ),
                            _c("i", {
                              staticClass: "iconfont icon-jinghao info_icon",
                              staticStyle: { "font-size": "15px" },
                            }),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: "任务编号",
                                  placement: "bottom",
                                  "popper-class": "texttooltip",
                                  "open-delay": 500,
                                },
                              },
                              [_c("div", [_vm._v("任务编号")])]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "info_value" },
                          [
                            _c("el-input", {
                              ref: "input_name",
                              attrs: {
                                autofocus: true,
                                placeholder: "点击添加",
                              },
                              model: {
                                value: _vm.dialogCreat.taskNumber,
                                callback: function ($$v) {
                                  _vm.$set(_vm.dialogCreat, "taskNumber", $$v)
                                },
                                expression: "dialogCreat.taskNumber",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm.dialogCreat.title == "创建任务" && !_vm.proId
                        ? _c("div", { staticClass: "info" }, [
                            _c(
                              "div",
                              { staticClass: "info_key" },
                              [
                                _c("div", { staticStyle: { width: "11px" } }),
                                _c("i", {
                                  staticClass:
                                    "iconfont icon-xiangmu info_icon",
                                  staticStyle: { "font-size": "12px" },
                                }),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "所属项目",
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [_c("div", [_vm._v("所属项目")])]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "info_value" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      filterable: "",
                                      placeholder: "请选择所属项目",
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.describes.proId =
                                          _vm.dialogCreat.proId
                                      },
                                    },
                                    model: {
                                      value: _vm.dialogCreat.proId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.dialogCreat, "proId", $$v)
                                      },
                                      expression: "dialogCreat.proId",
                                    },
                                  },
                                  _vm._l(_vm.proType, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.proname,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "info" }, [
                        _c(
                          "div",
                          { staticClass: "info_key" },
                          [
                            _c("div", { staticStyle: { width: "11px" } }),
                            _c("i", {
                              staticClass: "iconfont icon-type info_icon",
                              staticStyle: { "font-size": "13px" },
                            }),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: "任务类型",
                                  placement: "bottom",
                                  "popper-class": "texttooltip",
                                  "open-delay": 500,
                                },
                              },
                              [_c("div", [_vm._v("任务类型")])]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "info_value" },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择任务类型" },
                                on: { blur: _vm.getChoiceList },
                                model: {
                                  value: _vm.dialogCreat.taskType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dialogCreat, "taskType", $$v)
                                  },
                                  expression: "dialogCreat.taskType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "标准任务", value: "0" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "流程任务", value: "1" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm.dialogCreat.taskType == "1"
                        ? _c("div", { staticClass: "info" }, [
                            _c(
                              "div",
                              { staticClass: "info_key" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      color: "#ff4d42",
                                      "margin-right": "3px",
                                    },
                                  },
                                  [_vm._v("*")]
                                ),
                                _c("i", {
                                  staticClass: "iconfont icon-task info_icon",
                                  staticStyle: { "font-size": "12px" },
                                }),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "工作流程",
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [_c("div", [_vm._v("工作流程")])]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "info_value" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      filterable: "",
                                      placeholder: "请选择流程类型",
                                      "open-delay": 500,
                                    },
                                    on: { change: _vm.processDeta },
                                    model: {
                                      value: _vm.dialogCreat.flowId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.dialogCreat, "flowId", $$v)
                                      },
                                      expression: "dialogCreat.flowId",
                                    },
                                  },
                                  _vm._l(_vm.options, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.flowName,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "info" }, [
                        _c(
                          "div",
                          { staticClass: "info_key" },
                          [
                            _c("div", { staticStyle: { width: "11px" } }),
                            _c("i", {
                              staticClass: "iconfont icon-type info_icon",
                              staticStyle: { "font-size": "13px" },
                            }),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: "表单类型",
                                  placement: "bottom",
                                  "popper-class": "texttooltip",
                                  "open-delay": 500,
                                },
                              },
                              [_c("div", [_vm._v("表单类型")])]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "info_value" },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "请选择表单类型",
                                },
                                on: { change: _vm.formDetail },
                                model: {
                                  value: _vm.dialogCreat.formId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dialogCreat, "formId", $$v)
                                  },
                                  expression: "dialogCreat.formId",
                                },
                              },
                              _vm._l(_vm.formList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.formName,
                                    value: item.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm.dialogCreat.taskType == "0"
                        ? _c("div", { staticClass: "info" }, [
                            _c(
                              "div",
                              { staticClass: "info_key" },
                              [
                                _c("div", { staticStyle: { width: "11px" } }),
                                _c("i", {
                                  staticClass:
                                    "iconfont icon-fuzeren info_icon",
                                }),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "负责人",
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [_c("div", [_vm._v("负责人")])]
                                ),
                              ],
                              1
                            ),
                            _vm.dialogCreat.responseUsers.length > 0
                              ? _c("div", { staticClass: "info_value" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "personnel",
                                      staticStyle: {
                                        width: "83%",
                                        display: "flex",
                                        "align-items": "flex-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "draggable",
                                        {
                                          staticStyle: {
                                            width: "calc(100% - 70px)",
                                          },
                                          attrs: {
                                            group: "responseUsers",
                                            options: {
                                              handle: ".info_personnel1",
                                            },
                                            animation: "500",
                                          },
                                          model: {
                                            value:
                                              _vm.dialogCreat.responseUsers,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.dialogCreat,
                                                "responseUsers",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dialogCreat.responseUsers",
                                          },
                                        },
                                        [
                                          _c(
                                            "transition-group",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-wrap": "wrap",
                                              },
                                            },
                                            _vm._l(
                                              _vm.dialogCreat.responseUsers,
                                              function (item, index2) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index2,
                                                    staticClass:
                                                      "user_personnel",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.contactCh(
                                                          _vm.dialogCreat
                                                            .responseUsers,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm.channel === "ding"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel1",
                                                          },
                                                          [
                                                            item.avatar != "" &&
                                                            item.avatar != null
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "info_personnel_surname1",
                                                                  attrs: {
                                                                    src: item.avatar,
                                                                  },
                                                                })
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "info_personnel_surname1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.name.substring(
                                                                            0,
                                                                            1
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.channel === "wechat"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel1",
                                                          },
                                                          [
                                                            item.avatar != "" &&
                                                            item.avatar != null
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "info_personnel_surname1",
                                                                  attrs: {
                                                                    src: item.avatar,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "ww-open-data",
                                                                  {
                                                                    attrs: {
                                                                      type: "userName",
                                                                      openid:
                                                                        item.name,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c("i", {
                                                      staticClass:
                                                        "iconfont icon-shanchu del_icon",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.delUsers(
                                                            _vm.dialogCreat
                                                              .responseUsers,
                                                            index2,
                                                            1
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "bottom-start",
                                            width: "440",
                                            trigger: "click",
                                          },
                                          model: {
                                            value: _vm.responseUsers_popover,
                                            callback: function ($$v) {
                                              _vm.responseUsers_popover = $$v
                                            },
                                            expression: "responseUsers_popover",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "select_type" },
                                            [
                                              _c("span", [
                                                _vm._v("确认方式选择 "),
                                              ]),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    "popper-class":
                                                      "texttooltip",
                                                    placement: "right",
                                                    "open-delay": 500,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "content",
                                                      },
                                                      slot: "content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 顺签：指定人依次完成"
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "或签：某一指定人完成 "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "会签：所有指定人完成 "
                                                      ),
                                                    ]
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "iconfont icon-shuoming progress_icon",
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "select_type_radio",
                                                },
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      model: {
                                                        value:
                                                          _vm.dialogCreat
                                                            .responseType,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dialogCreat,
                                                            "responseType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dialogCreat.responseType",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: { label: "0" },
                                                        },
                                                        [_vm._v("顺签")]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: { label: "1" },
                                                        },
                                                        [_vm._v("或签")]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: { label: "2" },
                                                        },
                                                        [_vm._v("会签")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "select__type_personnel",
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v("负责人选择"),
                                                  ]),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "select__type_personnel_clear",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          _vm.dialogCreat.responseUsers =
                                                            []
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" 清空 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "users_personnel1",
                                                },
                                                [
                                                  _c(
                                                    "draggable",
                                                    {
                                                      attrs: {
                                                        group: "responseUsers1",
                                                        options: {
                                                          handle:
                                                            ".info_personnel1",
                                                        },
                                                        animation: "500",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dialogCreat
                                                            .responseUsers,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dialogCreat,
                                                            "responseUsers",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dialogCreat.responseUsers",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "flex-wrap": "wrap",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.dialogCreat
                                                            .responseUsers,
                                                          function (
                                                            item,
                                                            index2
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: index2,
                                                                staticClass:
                                                                  "user_personnel",
                                                              },
                                                              [
                                                                _vm.channel ===
                                                                "ding"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "info_personnel1",
                                                                      },
                                                                      [
                                                                        item.avatar !=
                                                                          "" &&
                                                                        item.avatar !=
                                                                          null
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "info_personnel_surname1",
                                                                                attrs:
                                                                                  {
                                                                                    src: item.avatar,
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "info_personnel_surname1",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      item.name.substring(
                                                                                        0,
                                                                                        1
                                                                                      )
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                        _c(
                                                                          "div",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.name
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm.channel ===
                                                                "wechat"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "info_personnel1",
                                                                      },
                                                                      [
                                                                        item.avatar !=
                                                                          "" &&
                                                                        item.avatar !=
                                                                          null
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "info_personnel_surname1",
                                                                                attrs:
                                                                                  {
                                                                                    src: item.avatar,
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _vm._e(),
                                                                        _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "ww-open-data",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    type: "userName",
                                                                                    openid:
                                                                                      item.name,
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _c("i", {
                                                                  staticClass:
                                                                    "iconfont icon-shanchu del_icon",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.delUsers(
                                                                          _vm
                                                                            .dialogCreat
                                                                            .responseUsers,
                                                                          index2,
                                                                          1
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "iconfont icon-jiahao2fill add_icon",
                                                    style:
                                                      _vm.dialogCreat
                                                        .responseUsers &&
                                                      _vm.dialogCreat
                                                        .responseUsers.length >
                                                        0
                                                        ? "margin-left:34px"
                                                        : "",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.contactCh(
                                                          _vm.dialogCreat
                                                            .responseUsers,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.dialogCreat
                                                          .responseUsers
                                                          .length > 1,
                                                      expression:
                                                        "dialogCreat.responseUsers.length > 1",
                                                    },
                                                  ],
                                                  staticStyle: {
                                                    width: "70px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      _vm.responseUsers_popover = true
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.dialogCreat
                                                              .responseType ==
                                                            0,
                                                          expression:
                                                            "dialogCreat.responseType == 0",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "info_personnel",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-shuzishunxu info_icon",
                                                      }),
                                                      _c("div", [
                                                        _vm._v("顺签"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.dialogCreat
                                                              .responseType ==
                                                            1,
                                                          expression:
                                                            "dialogCreat.responseType == 1",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "info_personnel",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-feijiaoxuedanweikaohebiaozhungonggongshiwubufen-kaohe info_icon",
                                                      }),
                                                      _c("div", [
                                                        _vm._v("或签"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.dialogCreat
                                                              .responseType ==
                                                            2,
                                                          expression:
                                                            "dialogCreat.responseType == 2",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "info_personnel",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-KJ_012 info_icon",
                                                      }),
                                                      _c("div", [
                                                        _vm._v("会签"),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "type",
                                      staticStyle: {
                                        width: "15%",
                                        "text-align": "right",
                                        "margin-right": "15px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "type_text",
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.contactCh(
                                                _vm.dialogCreat.responseUsers,
                                                1
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 选择人员 ")]
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", { staticClass: "info_value" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "add_text",
                                      on: {
                                        click: function ($event) {
                                          return _vm.contactCh(
                                            _vm.dialogCreat.responseUsers,
                                            1
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 点击添加 ")]
                                  ),
                                ]),
                          ])
                        : _vm._e(),
                      _vm.dialogCreat.taskType == "0"
                        ? _c("div", { staticClass: "info" }, [
                            _c(
                              "div",
                              { staticClass: "info_key" },
                              [
                                _c("div", { staticStyle: { width: "11px" } }),
                                _c("i", {
                                  staticClass:
                                    "iconfont icon-querenren info_icon",
                                }),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "确认人",
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [_c("div", [_vm._v("确认人")])]
                                ),
                              ],
                              1
                            ),
                            _vm.dialogCreat.confirmUsers.length > 0
                              ? _c("div", { staticClass: "info_value" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "personnel",
                                      staticStyle: {
                                        width: "83%",
                                        display: "flex",
                                        "align-items": "flex-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "draggable",
                                        {
                                          staticStyle: {
                                            width: "calc(100% - 70px)",
                                          },
                                          attrs: {
                                            group: "confirmUsers",
                                            options: {
                                              handle: ".info_personnel1",
                                            },
                                            animation: "500",
                                          },
                                          model: {
                                            value: _vm.dialogCreat.confirmUsers,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.dialogCreat,
                                                "confirmUsers",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dialogCreat.confirmUsers",
                                          },
                                        },
                                        [
                                          _c(
                                            "transition-group",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-wrap": "wrap",
                                              },
                                            },
                                            _vm._l(
                                              _vm.dialogCreat.confirmUsers,
                                              function (item, index2) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index2,
                                                    staticClass:
                                                      "user_personnel",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.contactCh(
                                                          _vm.dialogCreat
                                                            .confirmUsers,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm.channel === "ding"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel1",
                                                          },
                                                          [
                                                            item.avatar != "" &&
                                                            item.avatar != null
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "info_personnel_surname1",
                                                                  attrs: {
                                                                    src: item.avatar,
                                                                  },
                                                                })
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "info_personnel_surname1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.name.substring(
                                                                            0,
                                                                            1
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.channel === "wechat"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel1",
                                                          },
                                                          [
                                                            item.avatar != "" &&
                                                            item.avatar != null
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "info_personnel_surname1",
                                                                  attrs: {
                                                                    src: item.avatar,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "ww-open-data",
                                                                  {
                                                                    attrs: {
                                                                      type: "userName",
                                                                      openid:
                                                                        item.name,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c("i", {
                                                      staticClass:
                                                        "iconfont icon-shanchu del_icon",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.delUsers(
                                                            _vm.dialogCreat
                                                              .confirmUsers,
                                                            index2,
                                                            2
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "bottom-start",
                                            width: "440",
                                            trigger: "click",
                                          },
                                          model: {
                                            value: _vm.confirmUsers_popover,
                                            callback: function ($$v) {
                                              _vm.confirmUsers_popover = $$v
                                            },
                                            expression: "confirmUsers_popover",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "select_type" },
                                            [
                                              _c("span", [
                                                _vm._v("确认方式选择 "),
                                              ]),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    "popper-class":
                                                      "texttooltip",
                                                    placement: "right",
                                                    "open-delay": 500,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "content",
                                                      },
                                                      slot: "content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 顺签：指定人依次完成"
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "或签：某一指定人完成 "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "会签：所有指定人完成 "
                                                      ),
                                                    ]
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "iconfont icon-shuoming progress_icon",
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "select_type_radio",
                                                },
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      model: {
                                                        value:
                                                          _vm.dialogCreat
                                                            .confirmType,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dialogCreat,
                                                            "confirmType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dialogCreat.confirmType",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: { label: "0" },
                                                        },
                                                        [_vm._v("顺签")]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: { label: "1" },
                                                        },
                                                        [_vm._v("或签")]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          attrs: { label: "2" },
                                                        },
                                                        [_vm._v("会签")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "select__type_personnel",
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v("确认人选择"),
                                                  ]),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "select__type_personnel_clear",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          _vm.dialogCreat.confirmUsers =
                                                            []
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" 清空 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "users_personnel1",
                                                },
                                                [
                                                  _c(
                                                    "draggable",
                                                    {
                                                      attrs: {
                                                        group: "confirmUsers1",
                                                        options: {
                                                          handle:
                                                            ".info_personnel1",
                                                        },
                                                        animation: "500",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.dialogCreat
                                                            .confirmUsers,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.dialogCreat,
                                                            "confirmUsers",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "dialogCreat.confirmUsers",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "transition-group",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "flex-wrap": "wrap",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.dialogCreat
                                                            .confirmUsers,
                                                          function (
                                                            item,
                                                            index2
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: index2,
                                                                staticClass:
                                                                  "user_personnel1",
                                                              },
                                                              [
                                                                _vm.channel ===
                                                                "ding"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "info_personnel1",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                              return _vm.contactCh(
                                                                                _vm
                                                                                  .dialogCreat
                                                                                  .confirmUsers,
                                                                                2
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        item.avatar !=
                                                                          "" &&
                                                                        item.avatar !=
                                                                          null
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "info_personnel_surname1",
                                                                                attrs:
                                                                                  {
                                                                                    src: item.avatar,
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "info_personnel_surname1",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      item.name.substring(
                                                                                        0,
                                                                                        1
                                                                                      )
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                        _c(
                                                                          "div",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.name
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm.channel ===
                                                                "wechat"
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "info_personnel1",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                              return _vm.contactCh(
                                                                                _vm
                                                                                  .dialogCreat
                                                                                  .confirmUsers,
                                                                                2
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        item.avatar !=
                                                                          "" &&
                                                                        item.avatar !=
                                                                          null
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "info_personnel_surname1",
                                                                                attrs:
                                                                                  {
                                                                                    src: item.avatar,
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _vm._e(),
                                                                        _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "ww-open-data",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    type: "userName",
                                                                                    openid:
                                                                                      item.name,
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _c("i", {
                                                                  staticClass:
                                                                    "iconfont icon-shanchu del_icon",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.delUsers(
                                                                          _vm
                                                                            .dialogCreat
                                                                            .confirmUsers,
                                                                          index2,
                                                                          2
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "iconfont icon-jiahao2fill add_icon",
                                                    style:
                                                      _vm.dialogCreat
                                                        .confirmUsers &&
                                                      _vm.dialogCreat
                                                        .confirmUsers.length > 0
                                                        ? "margin-left:34px"
                                                        : "",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.contactCh(
                                                          _vm.dialogCreat
                                                            .confirmUsers,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.dialogCreat
                                                          .confirmUsers.length >
                                                        1,
                                                      expression:
                                                        "dialogCreat.confirmUsers.length > 1",
                                                    },
                                                  ],
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      _vm.confirmUsers_popover = true
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.dialogCreat
                                                              .confirmType == 0,
                                                          expression:
                                                            "dialogCreat.confirmType == 0",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "info_personnel",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-shuzishunxu info_icon",
                                                      }),
                                                      _c("div", [
                                                        _vm._v("顺签"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.dialogCreat
                                                              .confirmType == 1,
                                                          expression:
                                                            "dialogCreat.confirmType == 1",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "info_personnel",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-feijiaoxuedanweikaohebiaozhungonggongshiwubufen-kaohe info_icon",
                                                      }),
                                                      _c("div", [
                                                        _vm._v("或签"),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.dialogCreat
                                                              .confirmType == 2,
                                                          expression:
                                                            "dialogCreat.confirmType == 2",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "info_personnel",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-KJ_012 info_icon",
                                                      }),
                                                      _c("div", [
                                                        _vm._v("会签"),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "type",
                                      staticStyle: {
                                        width: "15%",
                                        "text-align": "right",
                                        "margin-right": "15px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "type_text",
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.contactCh(
                                                _vm.dialogCreat.confirmUsers,
                                                2
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 选择人员 ")]
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", { staticClass: "info_value" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "add_text",
                                      on: {
                                        click: function ($event) {
                                          return _vm.contactCh(
                                            _vm.dialogCreat.confirmUsers,
                                            2
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 点击添加 ")]
                                  ),
                                ]),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "info" }, [
                        _c(
                          "div",
                          { staticClass: "info_key" },
                          [
                            _c("div", { staticStyle: { width: "11px" } }),
                            _c("i", {
                              staticClass: "iconfont icon-riqi info_icon",
                              staticStyle: { "font-size": "17px" },
                            }),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: "计划开始",
                                  placement: "bottom",
                                  "popper-class": "texttooltip",
                                  "open-delay": 500,
                                },
                              },
                              [_c("div", [_vm._v("计划开始")])]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "info_value" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "block" },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "170px" },
                                  attrs: {
                                    type: "datetime",
                                    "value-format": "yyyy/MM/dd HH:mm:ss",
                                    format: "yyyy/MM/dd HH:mm:ss",
                                    placeholder: "选择日期时间",
                                    "picker-options": _vm.pickerOptions,
                                    "default-time":
                                      _vm.dialogCreat.defaultime.startTime,
                                  },
                                  on: {
                                    focus: _vm.focusStartChange,
                                    blur: _vm.blurChange,
                                  },
                                  model: {
                                    value: _vm.dialogCreat.planStartDate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dialogCreat,
                                        "planStartDate",
                                        $$v
                                      )
                                    },
                                    expression: "dialogCreat.planStartDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: "计划截止",
                                    placement: "bottom",
                                    "popper-class": "texttooltip",
                                    "open-delay": 500,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "date_label",
                                      staticStyle: { margin: "0 10px 0 5px" },
                                    },
                                    [_vm._v("计划截止")]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "inline-block" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "block" },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "170px" },
                                        attrs: {
                                          type: "datetime",
                                          "value-format": "yyyy/MM/dd HH:mm:ss",
                                          format: "yyyy/MM/dd HH:mm:ss",
                                          placeholder: "选择日期时间",
                                          "picker-options": _vm.pickerOptions1,
                                          "default-time":
                                            _vm.dialogCreat.defaultime.endTime,
                                        },
                                        on: {
                                          focus: _vm.focusEndChange,
                                          blur: _vm.blurChange,
                                        },
                                        model: {
                                          value: _vm.dialogCreat.planEndDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.dialogCreat,
                                              "planEndDate",
                                              $$v
                                            )
                                          },
                                          expression: "dialogCreat.planEndDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("div", [
                            _c(
                              "span",
                              [
                                _c(
                                  "el-dropdown",
                                  {
                                    attrs: {
                                      trigger: "click",
                                      "hide-on-click": false,
                                    },
                                    on: { command: _vm.selectWorkType },
                                  },
                                  [
                                    _c("span", { staticClass: "date_label" }, [
                                      _vm._v("工期 "),
                                      _vm.dialogCreat.workTimeType === "0"
                                        ? _c("span", [_vm._v("(自然日)")])
                                        : _vm._e(),
                                      _vm.dialogCreat.workTimeType === "1"
                                        ? _c("span", [_vm._v("(工作日)")])
                                        : _vm._e(),
                                    ]),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown",
                                      },
                                      [
                                        _c(
                                          "el-dropdown-item",
                                          { attrs: { command: "0" } },
                                          [_vm._v("自然日")]
                                        ),
                                        _c(
                                          "el-dropdown-item",
                                          { attrs: { command: "1" } },
                                          [_vm._v("工作日")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  [
                                    _c("el-input", {
                                      staticClass: "time_input",
                                      staticStyle: {
                                        margin: "0 5px 0 -20px",
                                        padding: "0",
                                        height: "36px",
                                        width: "55px",
                                      },
                                      model: {
                                        value: _vm.dialogCreat.planWorkTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dialogCreat,
                                            "planWorkTime",
                                            $$v
                                          )
                                        },
                                        expression: "dialogCreat.planWorkTime",
                                      },
                                    }),
                                    _c("span", [_vm._v("天")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._l(_vm.roleList, function (item, index) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.dialogCreat.taskType == "1",
                                expression: "dialogCreat.taskType == '1'",
                              },
                            ],
                            key: index,
                            staticClass: "info",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "info_key" },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.mustFlag === "1",
                                        expression: "item.mustFlag === '1'",
                                      },
                                    ],
                                    staticStyle: {
                                      color: "#ff4d42",
                                      "margin-right": "3px",
                                    },
                                  },
                                  [_vm._v("*")]
                                ),
                                _c("div", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.mustFlag !== "1",
                                      expression: "item.mustFlag !== '1'",
                                    },
                                  ],
                                  staticStyle: { width: "9px" },
                                }),
                                _c("i", {
                                  staticClass: "iconfont icon-renqun info_icon",
                                  staticStyle: { "font-size": "12px" },
                                }),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: item.roleName,
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "rolename" }, [
                                      _vm._v(_vm._s(item.roleName)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            item.userList.length > 0
                              ? _c("div", { staticClass: "info_value" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "personnel",
                                      staticStyle: {
                                        width: "100%",
                                        display: "flex",
                                        "align-items": "flex-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "draggable",
                                        {
                                          attrs: {
                                            group: "item.userList",
                                            options: {
                                              handle: ".info_personnel1",
                                            },
                                            animation: "500",
                                          },
                                          model: {
                                            value: item.userList,
                                            callback: function ($$v) {
                                              _vm.$set(item, "userList", $$v)
                                            },
                                            expression: "item.userList",
                                          },
                                        },
                                        [
                                          _c(
                                            "transition-group",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-wrap": "wrap",
                                              },
                                            },
                                            _vm._l(
                                              item.userList,
                                              function (itemF, index2) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index2,
                                                    staticClass:
                                                      "info_value_text",
                                                    staticStyle: {
                                                      display: "flex",
                                                      "align-items": "center",
                                                      "flex-wrap": "wrap",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.contactCh(
                                                          item.userList,
                                                          item.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "user_personnel",
                                                      },
                                                      [
                                                        _vm.channel === "ding"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "info_personnel1",
                                                              },
                                                              [
                                                                itemF.avatar !=
                                                                  "" &&
                                                                itemF.avatar !=
                                                                  null
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "info_personnel_surname1",
                                                                      attrs: {
                                                                        src: itemF.avatar,
                                                                      },
                                                                    })
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "info_personnel_surname1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              itemF.name.substring(
                                                                                0,
                                                                                1
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                _c("div", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      itemF.name
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm.channel === "wechat"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "info_personnel1",
                                                              },
                                                              [
                                                                itemF.avatar !=
                                                                  "" &&
                                                                itemF.avatar !=
                                                                  null
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "info_personnel_surname1",
                                                                      attrs: {
                                                                        src: itemF.avatar,
                                                                      },
                                                                    })
                                                                  : _vm._e(),
                                                                _c(
                                                                  "div",
                                                                  [
                                                                    _c(
                                                                      "ww-open-data",
                                                                      {
                                                                        attrs: {
                                                                          type: "userName",
                                                                          openid:
                                                                            itemF.name,
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont icon-shanchu del_icon",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.delUsers(
                                                                item.userList,
                                                                index2,
                                                                item.id
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c("i", {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            item.userList
                                                              .length -
                                                              1 ==
                                                            index2,
                                                          expression:
                                                            "item.userList.length - 1 == index2",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "iconfont icon-jiahao2fill add_icon",
                                                      staticStyle: {
                                                        margin: "0 24px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.contactCh(
                                                            item.userList,
                                                            item.id
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _c("div", { staticClass: "info_value" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "add_text",
                                      on: {
                                        click: function ($event) {
                                          return _vm.contactCh(
                                            item.userList,
                                            item.id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 点击添加 ")]
                                  ),
                                ]),
                          ]
                        )
                      }),
                      _vm.dialogCreat.taskType == "1" &&
                      _vm.corpId === "ding379884b8b194a55f35c2f4657eb6378f"
                        ? _c("div", { staticClass: "info" }, [
                            _c(
                              "div",
                              { staticClass: "info_key" },
                              [
                                _c("div", { staticStyle: { width: "11px" } }),
                                _c("i", {
                                  staticClass: "iconfont icon-riqi info_icon",
                                  staticStyle: { "font-size": "17px" },
                                }),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "预计完成",
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "form_fieldName" },
                                      [_vm._v("预计完成")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "info_value" }, [
                              _c("div", { staticStyle: { width: "100%" } }, [
                                _c(
                                  "div",
                                  { staticClass: "block" },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "datetime",
                                        "value-format": "yyyy/MM/dd HH:mm:ss",
                                        format: "yyyy/MM/dd",
                                        placeholder: "选择预计完成日期",
                                        "picker-options": _vm.pickerOptions,
                                        "default-time": "00:00:00",
                                      },
                                      on: {
                                        focus: _vm.focusStartChange,
                                        blur: _vm.blurChange,
                                      },
                                      model: {
                                        value: _vm.dialogCreat.prodPlanEndDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dialogCreat,
                                            "prodPlanEndDate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dialogCreat.prodPlanEndDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.dialogCreat.formId && _vm.dialogCreat.formId != "0"
                        ? _c("Form", {
                            attrs: {
                              "form-json": _vm.formJson,
                              "pro-id": _vm.dialogCreat.proId,
                              formdetail: _vm.formDetailValue,
                              "creat-type": "",
                            },
                            on: { addForm: _vm.addForm },
                          })
                        : _vm._e(),
                      _vm.dialogCreat.formId == "" ||
                      _vm.dialogCreat.formId == "0"
                        ? _c("div", { staticClass: "info" }, [
                            _c(
                              "div",
                              { staticClass: "info_key" },
                              [
                                _c("div", { staticStyle: { width: "11px" } }),
                                _c("i", {
                                  staticClass:
                                    "iconfont icon-describe info_icon",
                                  staticStyle: { "font-size": "14px" },
                                }),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "描述",
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [_c("div", [_vm._v("描述")])]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "85%",
                                  "margin-top": "5px",
                                },
                              },
                              [
                                _c("Describe", {
                                  attrs: { describes: _vm.describes },
                                  on: { func: _vm.addtask },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm.dialogCreat.flowId
                        ? _c("div", { staticClass: "info" }, [
                            _c(
                              "div",
                              { staticClass: "info_key" },
                              [
                                _c("div", { staticStyle: { width: "11px" } }),
                                _c("i", {
                                  staticClass: "iconfont icon-renqun info_icon",
                                  staticStyle: { "font-size": "12px" },
                                }),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "关注人",
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [_c("div", [_vm._v("关注人")])]
                                ),
                              ],
                              1
                            ),
                            _vm.formDetailValue.followUsers &&
                            _vm.formDetailValue.followUsers.length > 0
                              ? _c("div", { staticClass: "info_value" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "info_followUsers",
                                      staticStyle: { margin: "0" },
                                    },
                                    [
                                      _c(
                                        "draggable",
                                        {
                                          attrs: {
                                            group: "followUserList",
                                            options: {
                                              handle: ".info_personnel1",
                                            },
                                            animation: "500",
                                          },
                                          model: {
                                            value:
                                              _vm.formDetailValue.followUsers,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formDetailValue,
                                                "followUsers",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formDetailValue.followUsers",
                                          },
                                        },
                                        [
                                          _c(
                                            "transition-group",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-wrap": "wrap",
                                              },
                                            },
                                            _vm._l(
                                              _vm.formDetailValue.followUsers,
                                              function (item, index2) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index2,
                                                    staticClass:
                                                      "info_personnel_followUsers",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.contactCh(
                                                          _vm.formDetailValue
                                                            .followUsers,
                                                          3
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm.channel === "ding" &&
                                                    item.userType === "1"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel1",
                                                            staticStyle: {
                                                              padding: "0",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-tooltip",
                                                              {
                                                                staticClass:
                                                                  "item",
                                                                attrs: {
                                                                  effect:
                                                                    "dark",
                                                                  content:
                                                                    item.name,
                                                                  placement:
                                                                    "bottom",
                                                                },
                                                              },
                                                              [
                                                                item.avatar !=
                                                                  "" &&
                                                                item.avatar !=
                                                                  null
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "info_personnel_surname1",
                                                                      attrs: {
                                                                        src: item.avatar,
                                                                      },
                                                                    })
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "info_personnel_surname1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              item.name.substring(
                                                                                0,
                                                                                1
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm.channel === "wechat" &&
                                                    item.userType === "1"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel1",
                                                            staticStyle: {
                                                              padding: "0",
                                                            },
                                                          },
                                                          [
                                                            item.avatar != "" &&
                                                            item.avatar != null
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "info_personnel_surname1",
                                                                  attrs: {
                                                                    src: item.avatar,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c("i", {
                                                      staticClass:
                                                        "iconfont icon-shanchu del_icon",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.delUsers(
                                                            _vm.formDetailValue
                                                              .followUsers,
                                                            index2,
                                                            3
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "iconfont icon-jiahao2fill add_icon",
                                        staticStyle: { margin: "0 24px" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.contactCh(
                                              _vm.formDetailValue.followUsers,
                                              3
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _c("div", { staticClass: "info_value" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "add_text",
                                      on: {
                                        click: function ($event) {
                                          return _vm.contactCh(
                                            _vm.formDetailValue.followUsers,
                                            3
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 点击添加 ")]
                                  ),
                                ]),
                          ])
                        : _c("div", { staticClass: "info" }, [
                            _c(
                              "div",
                              { staticClass: "info_key" },
                              [
                                _c("div", { staticStyle: { width: "11px" } }),
                                _c("i", {
                                  staticClass: "iconfont icon-renqun info_icon",
                                  staticStyle: { "font-size": "12px" },
                                }),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: "关注人",
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [_c("div", [_vm._v("关注人")])]
                                ),
                              ],
                              1
                            ),
                            _vm.dialogCreat.followUserList.length > 0
                              ? _c("div", { staticClass: "info_value" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "info_followUsers",
                                      staticStyle: { margin: "0" },
                                    },
                                    [
                                      _c(
                                        "draggable",
                                        {
                                          attrs: {
                                            group: "followUserList",
                                            options: {
                                              handle: ".info_personnel1",
                                            },
                                            animation: "500",
                                          },
                                          model: {
                                            value:
                                              _vm.dialogCreat.followUserList,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.dialogCreat,
                                                "followUserList",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dialogCreat.followUserList",
                                          },
                                        },
                                        [
                                          _c(
                                            "transition-group",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-wrap": "wrap",
                                              },
                                            },
                                            _vm._l(
                                              _vm.dialogCreat.followUserList,
                                              function (item, index2) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index2,
                                                    staticClass:
                                                      "info_personnel_followUsers",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.contactCh(
                                                          _vm.dialogCreat
                                                            .followUserList,
                                                          3
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm.channel === "ding"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel1",
                                                            staticStyle: {
                                                              padding: "0",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-tooltip",
                                                              {
                                                                staticClass:
                                                                  "item",
                                                                attrs: {
                                                                  effect:
                                                                    "dark",
                                                                  content:
                                                                    item.name,
                                                                  placement:
                                                                    "bottom",
                                                                  "open-delay": 500,
                                                                },
                                                              },
                                                              [
                                                                item.avatar !=
                                                                  "" &&
                                                                item.avatar !=
                                                                  null
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "info_personnel_surname1",
                                                                      attrs: {
                                                                        src: item.avatar,
                                                                      },
                                                                    })
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "info_personnel_surname1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              item.name.substring(
                                                                                0,
                                                                                1
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm.channel === "wechat"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel1",
                                                            staticStyle: {
                                                              padding: "0",
                                                            },
                                                          },
                                                          [
                                                            item.avatar != "" &&
                                                            item.avatar != null
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "info_personnel_surname1",
                                                                  attrs: {
                                                                    src: item.avatar,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c("i", {
                                                      staticClass:
                                                        "iconfont icon-shanchu del_icon",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.delUsers(
                                                            _vm.dialogCreat
                                                              .followUserList,
                                                            index2,
                                                            3
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "iconfont icon-jiahao2fill add_icon",
                                        staticStyle: { margin: "0 24px" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.contactCh(
                                              _vm.dialogCreat.followUserList,
                                              3
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _c("div", { staticClass: "info_value" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "add_text",
                                      on: {
                                        click: function ($event) {
                                          return _vm.contactCh(
                                            _vm.dialogCreat.followUserList,
                                            3
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 点击添加 ")]
                                  ),
                                ]),
                          ]),
                      _vm.dialogCreat.formId == "" ||
                      _vm.dialogCreat.formId == "0"
                        ? _c(
                            "div",
                            {
                              staticClass: "info",
                              staticStyle: { "margin-bottom": "20px" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "info_key" },
                                [
                                  _c("div", { staticStyle: { width: "11px" } }),
                                  _c("i", {
                                    staticClass: "iconfont icon-tag info_icon",
                                  }),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: "标签",
                                        placement: "bottom",
                                        "popper-class": "texttooltip",
                                        "open-delay": 500,
                                      },
                                    },
                                    [_c("div", [_vm._v("标签")])]
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "info_value" }, [
                                _c(
                                  "div",
                                  { staticClass: "info_box" },
                                  [
                                    _vm._l(
                                      _vm.dialogCreat.labelList,
                                      function (tag, index1) {
                                        return _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.dialogCreat.labelList &&
                                                  _vm.dialogCreat.labelList
                                                    .length > 0,
                                                expression:
                                                  "\n                    dialogCreat.labelList && dialogCreat.labelList.length > 0\n                  ",
                                              },
                                            ],
                                            key: index1,
                                            staticClass: "info_tags",
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticStyle: {
                                                  "margin-right": "16px",
                                                },
                                                style:
                                                  "color:" +
                                                  tag.color +
                                                  ";background:" +
                                                  _vm.convertHex(tag.color, 10),
                                                attrs: { type: "warning" },
                                              },
                                              [_vm._v(_vm._s(tag.labelName))]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-shanchu del_icon",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.delTagsChange(tag)
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "bottom",
                                          width: "540",
                                          trigger: "click",
                                        },
                                      },
                                      [
                                        _c("TagsList", {
                                          attrs: {
                                            "tags-objects": _vm.tagsObject,
                                            "tag-lists": _vm.tagList,
                                          },
                                        }),
                                        _c("i", {
                                          staticClass:
                                            "iconfont icon-jiahao2fill add_icon",
                                          style:
                                            _vm.dialogCreat.labelList &&
                                            _vm.dialogCreat.labelList.length > 0
                                              ? "margin: 0 10px;"
                                              : "margin: 0",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }